import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Modal } from 'antd';

import { pageChanged } from '../../../../../data/redux/page_details/actions';
import { emitMemberCustomEvent } from '../../../../../data/redux/member_details/actions';
import * as agentMonitoringActions from '../../../../../data/redux/agent_monitoring_details/actions';

import { APP_PAGES, SOCKET_EVENTS } from '../../../../../data/config/constants';
import { uniqueId } from '../../../../../data/config/utils';

import CustomHeader from '../../../../../components/customheader';
import ErrorBoundary from '../../../../../components/errorboundary';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import CardContainer from '../../../components/cardcontainer';
import AgentHandlingChats from './components/agenthandlingchats';
import ShareReport from './components/sharereport';

class AgentMonitoring extends React.PureComponent {
  constructor(props) {
    super(props);
    this.agentChatsRef = React.createRef();
    this.join_group_stats_called = false;
    this.state = {
      modal_data: {
        title: "",
        show_share_report: false,
      },
    }
  }

  componentDidMount() {
    const { actions, is_member_socket_connected } = this.props;
    if (is_member_socket_connected)
      actions.emitMemberCustomEvent(SOCKET_EVENTS.JOIN_GROUP_LIVE_STATS, {});
    actions.pageChanged(APP_PAGES.AGENT_MONITORING, APP_PAGES.ANALYTICS);
  }

  componentDidUpdate(prevProps) {
    const { is_member_socket_connected, actions, agent_monitoring_details } = this.props;
    if ((!prevProps.is_member_socket_connected || !this.join_group_stats_called) && is_member_socket_connected) {
      this.join_group_stats_called = true;
      actions.emitMemberCustomEvent(SOCKET_EVENTS.JOIN_GROUP_LIVE_STATS, {});
      if (agent_monitoring_details.expanded_group.group) {
        this.joinAgentLiveStats(agent_monitoring_details.expanded_group.group)
      }
    }
    if ((!prevProps.agent_monitoring_details.selected_agent.agent && this.props.agent_monitoring_details.selected_agent.agent !== null) || (prevProps.agent_monitoring_details.selected_agent && this.props.agent_monitoring_details.selected_agent.agent && prevProps.agent_monitoring_details.selected_agent.agent.psid !== this.props.agent_monitoring_details.selected_agent.agent.psid)) {
      this.agentChatsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  componentWillUnmount() {
    const { actions } = this.props;
    this.leaveAgentLiveStats();
    actions.emitMemberCustomEvent(SOCKET_EVENTS.LEAVE_GROUP_LIVE_STATS, {})
  }

  joinAgentLiveStats = group => {
    const { actions } = this.props;
    actions.updateAgentMonitoringState(true, 'loaders.agent_list_loading');
    actions.emitMemberCustomEvent(SOCKET_EVENTS.JOIN_AGENT_LIVE_STATS, { group: group.name }, err => {
      if (!err) {
        actions.updateAgentMonitoringState(group, 'expanded_group.group');
      }
    });
  }

  leaveAgentLiveStats = () => {
    const { actions, agent_monitoring_details } = this.props;
    if (agent_monitoring_details.expanded_group.group) {
      actions.emitMemberCustomEvent(SOCKET_EVENTS.LEAVE_AGENT_LIVE_STATS, { group: agent_monitoring_details.expanded_group.group.name });
      const expanded_group = {
        group: null,
        agents: { columns: [], data: [] },
      };
      actions.updateAgentMonitoringState(expanded_group, 'expanded_group');
    }
  }

  onRowExpand = (is_expand, group) => {
    this.leaveAgentLiveStats();
    if (is_expand)
      this.joinAgentLiveStats(group);
  };

  selectAgentData = agent => {
    const { actions } = this.props;
    actions.updateAgentMonitoringState(agent, 'selected_agent.agent');
  };

  clearSelectedAgent = () => {
    const { actions } = this.props;
    actions.updateAgentMonitoringState(null, 'selected_agent.agent');
  };

  onAgentsRow = record => {
    return {
      onClick: this.selectAgentData.bind(this, record)
    };
  };

  closeModal = () => {
    this.setState({
      modal_data: {
        title: "",
        show_share_report: false,
      }
    });
  };

  showShareReportPopup = () => {
    this.setState({
      modal_data: {
        title: "Share Report",
        show_share_report: true,
      }
    });
  };

  onClickReportSend = payload => {
    const { actions } = this.props;
    actions.sendReportToEmailId(payload, this.closeModal);
  }

  renderShareReportForm = () => {
    const { modal_data } = this.state;
    const { loaders } = this.props.agent_monitoring_details;
    if (modal_data.show_share_report) {
      return (
        <ErrorBoundary onErrorCallback={this.closeModal}>
          <ShareReport loading={loaders.report_sharing} handleCancelClick={this.closeModal} handleSendClick={this.onClickReportSend} />
        </ErrorBoundary>
      );
    }
  };

  renderAgentsTable = () => {
    const { screen_width } = this.props;
    const { expanded_group, loaders } = this.props.agent_monitoring_details;
    return (
      <Table className="ori-table-default ori-table-header-bg-transparent ori-table-content-align-center" rowClassName="ori-cursor-ptr ori-bg-white" scroll={{ x: 600 }} size={screen_width < 768 ? "small" : "middle"} rowKey={uniqueId} onRow={this.onAgentsRow} pagination={false} columns={expanded_group.agents.columns} dataSource={expanded_group.agents.data} loading={loaders.agent_list_loading} />
    );
  };

  renderGroupsTable = () => {
    const { screen_width } = this.props;
    const { groups, expanded_group } = this.props.agent_monitoring_details;
    if (groups.data.length === 0) {
      return (<CardRowTableLoader />);
    }
    return (
      <Table className="ori-card-row-table ori-table-row-expand-icon-cell ori-table-content-align-center" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" expandedRowKeys={expanded_group.group && expanded_group.group.key ? [expanded_group.group.key] : []} scroll={{ x: 700 }} size={screen_width < 768 ? "small" : "middle"} columns={groups.columns} dataSource={groups.data} pagination={false} expandedRowRender={this.renderAgentsTable} onExpand={this.onRowExpand} />
    );
  };

  renderAgentChats = () => {
    const { selected_agent } = this.props.agent_monitoring_details;
    if (selected_agent.agent) {
      const custom_header_props = {
        title: selected_agent.agent.name,
        container_class: "ori-lr-pad-10",
        bottom_bordered: true,
        show_first_button: true,
        first_button_class: 'ori-btn-fill-danger ori-font-xs ori-lr-pad-15',
        first_button_text: 'Close',
        onClickFirstButton: this.clearSelectedAgent
      };
      return (
        <CardContainer card_container_class="ori-animated ori-fade-in ori-box-shadow-light ori-tb-mrgn-5 ori-bg-white" custom_header_props={custom_header_props} container_height={500} load_error={false} loading={false} emtpy_condition={false} show_custom_header >
          <AgentHandlingChats isActionPermitted={this.props.isActionPermitted} />
        </CardContainer>
      );
    }
  };

  render() {
    const { modal_data } = this.state;
    return (
      <div className="ori-lr-pad-10 ori-b-pad-5">
        <CustomHeader container_class="ori-b-mrgn-10" title="Agent Monitoring" first_button_text="Share Report" first_button_type="primary" first_button_class="ori-font-xs ori-lr-pad-15" onClickFirstButton={this.showShareReportPopup} bottom_bordered show_first_button />
        {this.renderGroupsTable()}
        {this.renderAgentChats()}
        <Modal className="ori-modal-primary" title={modal_data.title} footer={null} visible={modal_data.show_share_report} maskClosable={false} onCancel={this.closeModal}>
          {this.renderShareReportForm()}
        </Modal>
        <div ref={this.agentChatsRef} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    agent_monitoring_details: state.agent_monitoring_details,
    is_member_socket_connected: state.member_details.is_socket_connected,
    screen_width: state.page_details.device_data.screen_width,
    screen_height: state.page_details.device_data.screen_height,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      Object.assign(
        {},
        {
          pageChanged,
          emitMemberCustomEvent
        },
        agentMonitoringActions
      ),
      dispatch
    ),
  };
};

AgentMonitoring.propTypes = {
  screen_width: PropTypes.number,
  screen_height: PropTypes.number,
  actions: PropTypes.object,
  agent_monitoring_details: PropTypes.object,
  is_member_socket_connected: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.object,
  isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(AgentMonitoring);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/agentmonitoring/index.js